export const getAccessToken = () => {
  let accessToken: any = null

  if (typeof window !== 'undefined') {
    accessToken = `Bearer ${JSON.parse(window.localStorage.getItem('userData')!)?.session}`
  }

  return accessToken
}